// Platform detection utilities for Capacitor
let _Capacitor = null;

function getCapacitor() {
  if (_Capacitor === null) {
    try {
      // Dynamic import to avoid breaking web builds
      _Capacitor = window.Capacitor || false;
    } catch {
      _Capacitor = false;
    }
  }
  return _Capacitor;
}

export function isNative() {
  const cap = getCapacitor();
  return cap && cap.isNativePlatform ? cap.isNativePlatform() : false;
}

export function isAndroid() {
  const cap = getCapacitor();
  return cap && cap.getPlatform ? cap.getPlatform() === 'android' : false;
}

export function isIOS() {
  const cap = getCapacitor();
  return cap && cap.getPlatform ? cap.getPlatform() === 'ios' : false;
}

export function isWeb() {
  return !isNative();
}
